import { render } from "./index.web.vue?vue&type=template&id=6b024194&scoped=true&ts=true"
import script from "./index.web.vue?vue&type=script&scoped=true&lang=ts"
export * from "./index.web.vue?vue&type=script&scoped=true&lang=ts"

import "./index.web.vue?vue&type=style&index=0&id=6b024194&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b024194"]])

export default __exports__